import React from 'react'
import { CapacityBoxProps } from './type'
import { useApp } from '@/core/contexts/app'
import { Container } from '@/components/base/gridview'

const CapacityBox: React.FC<CapacityBoxProps> = ({ data }) => {
  const app = useApp()
  return (
    <div className="Capacity-Box">
      <Container size="medium">
        <div className="Capacity-Box-inner">
          {data.map((item, index) => (
            <div className="Capacity-Box-inner-item" key={index}>
              <div
                className="title"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <div
                className="desc"
                dangerouslySetInnerHTML={{ __html: item.desc }}
              />
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

export default CapacityBox
